export interface BaseRequest<T = any> {
    data: any;
    others?: Map<string, any>;
}